export const SECURITY_PASSWORD = "SECURITY/PASSWORD";
export const SECURITY_PIN = "SECURITY/PIN";
